import { all } from "redux-saga/effects";
import sellerRegSaga from './sellerRegSaga'
import sellerProfileSaga from "./sellerProfileSaga";
import companyProfileSaga from "./companyProfileSaga";
import statusGraphSaga from "./statusGraphSaga";
import FAQSaga from "./FAQSaga";
import subSellerSignUpSaga from "./subSellerSignUpSaga";
import questionnaireSaga from "./questionnaireSaga";
import notificationSaga from "./notificationSaga";
import mySettingSaga from "./mySettingSaga"
import apiCredentialSaga from "./apiCredentialSaga";
import userSaga from "./userSaga";


function* watcherSaga() {
    yield all([
        sellerRegSaga(),
        sellerProfileSaga(),
        companyProfileSaga(),
        statusGraphSaga(),
        subSellerSignUpSaga(),
        FAQSaga(),
        questionnaireSaga(),
        notificationSaga(),
        mySettingSaga(),
        apiCredentialSaga(),
        userSaga()
    ])
}

export default watcherSaga